interface Props {
  color: string | "#D0DEE6",
}
const Cursor = (props: Props) => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="58" height="58" rx="4" fill="white" stroke={props.color} strokeWidth="2"/>
      <path d="M39.2232 33.4661H33.6285L36.5842 40.6383C36.6897 40.8844 36.6897 41.1305 36.5842 41.3766C36.4786 41.6227 36.3027 41.7985 36.0564 41.904L33.4702 43.0642C33.2239 43.1345 32.9776 43.1169 32.7313 43.0115C32.5201 42.9411 32.3618 42.7829 32.2562 42.5368L29.4589 35.7337L24.8671 40.4273C24.5856 40.7438 24.2513 40.8141 23.8643 40.6383C23.4772 40.4625 23.2837 40.1637 23.2837 39.7418V17.0648C23.2837 16.6429 23.4772 16.3617 23.8643 16.221C24.2865 16.0453 24.6208 16.098 24.8671 16.3793L39.9093 31.8312C40.1908 32.1125 40.2436 32.464 40.0676 32.8859C39.9269 33.2727 39.6454 33.4661 39.2232 33.4661Z" fill={props.color}/>
    </svg>
  )
}
export default Cursor;
